import { IMAGES, LINKS } from './site'

export type ServiceKey = 'auto' | 'residential' | 'shower' | 'commercial'

export interface Service {
  key: ServiceKey
  title: string
  description: string
  bullets: string[]
  image: string
  imageAlt: string
  href: string
  linkLabel: string
  quoteHref: string
}

export const services: Service[] = [
  {
    key: 'auto',
    title: 'Auto Glass',
    description:
      'Emergency auto glass repair, windshield repair and replacement, plus side, door and rear glass for cars, trucks, vans, fleets and semis.',
    bullets: [
      'Certified auto-glass technicians',
      'On-site ADAS calibration when required',
      'We help with most insurers',
    ],
    image: IMAGES.auto,
    imageAlt:
      'Kosin’s Glass technician inspecting a vehicle windshield before replacement',
    href: LINKS.auto,
    linkLabel: 'Auto glass services',
    quoteHref: `${LINKS.auto}#quote-form`,
  },
  {
    key: 'residential',
    title: 'Residential Glass',
    description:
      'Broken or foggy windows, door glass and custom glass for your home. Good frames? You may only need new glass.',
    bullets: [
      'Insulated glass unit replacement',
      'Mirrors, tabletops and screens',
      'Free in-home estimates',
    ],
    image: IMAGES.residential,
    imageAlt: 'Replacement home window glass installed in an existing frame',
    href: LINKS.residential,
    linkLabel: 'Residential glass services',
    quoteHref: `${LINKS.residential}#quote-form`,
  },
  {
    key: 'shower',
    title: 'Glass Shower Doors',
    description:
      'Custom shower doors, sliding enclosures and tub glass, measured and installed to fit your bathroom.',
    bullets: [
      'Frameless, Euro, semi-frameless and framed',
      'Glass textures and hardware choices',
      'Lifetime installation guarantee',
    ],
    image: IMAGES.shower,
    imageAlt:
      'Custom frameless glass shower enclosure installed by Kosin’s Glass',
    href: LINKS.shower,
    linkLabel: 'Glass shower doors',
    quoteHref: LINKS.contact,
  },
  {
    key: 'commercial',
    title: 'Commercial Glass',
    description:
      'Glass repair, replacement and new installations for businesses, builders and property managers throughout Southeast Michigan.',
    bullets: [
      'Storefront and entry systems',
      'Office glass walls and curtain walls',
      'Contract glazing for builders',
    ],
    image: IMAGES.commercial,
    imageAlt: 'Commercial storefront glass and entry system glazing',
    href: LINKS.commercial,
    linkLabel: 'Commercial glass services',
    quoteHref: `${LINKS.commercial}#quote-form`,
  },
]
